// extracted by mini-css-extract-plugin
export default {"message":"SellerIdentity-message","badge":"SellerIdentity-badge"};